<kf-overlay>
  <div class="overlay { state.containerClass }" draggable="true" >
    <template if="{ state.show }">
      <slot />
    </template>
  </div>

  <script>
    const MARGIN_X = 4;
    const MARGIN_Y = 4;
    const OVERLAY_SHOW = 'overlay-show';
    const OVERLAY_HIDE = 'overlay-hide';
    export default {
      state: {
        containerClass: 'overlay-hide',
        show: false,
        preservePosition: true, // また開いたときに同じ位置で開くかどうか
        firstTime: true,
        
        offsetX: 0, // dlg の左からのマウスの位置
        offsetY: 0, // dlg の上からのマウスの位置

        /** @type {HTMLElement | null} */
        dlg: null,
      },

      onBeforeMount(props) {
        // props: overlay, preserve-position
        this.state.show = !!props.overlay.show;
        this.state.preservePosition = props.preservePosition || props.preservePosition == '';
      },

      onBeforeUpdate(props) {
        const overlay = props.overlay;
        const dlg = this.state.dlg;
        if (overlay.show && !this.state.show) { // show
          this.state.show = !!overlay.show;
          this.state.containerClass = OVERLAY_SHOW;
          if (dlg == null) return;

          dlg.focus();
          if (overlay.size) dlg.style.width = overlay.size + 'px';
          if (overlay.x && overlay.y && (!this.state.preservePosition || this.state.firstTime)) {
            const left = overlay.x;
            const top = overlay.y;
            const maxX = window.innerWidth - MARGIN_X - (dlg.offsetWidth);
            const maxY = window.innerHeight - MARGIN_Y - (dlg.offsetHeight);
            dlg.style.left = Math.min(Math.max(left, MARGIN_X), maxX) + 'px';
            dlg.style.top = Math.min(Math.max(top, MARGIN_Y), maxY) + 'px';

            this.state.firstTime = false;
          }

        } else if (!overlay.show && this.state.show) { // hide
          this.state.containerClass = OVERLAY_HIDE;
          // animationend event が発動、そこで state.show を false に変える
        }
      },

      onUpdated() {
        const dlg = this.state.dlg;
        if (dlg == null) return;

        const left = dlg.offsetLeft;
        const top = dlg.offsetTop;
        const maxX = window.innerWidth - MARGIN_X - (dlg.offsetWidth);
        const maxY = window.innerHeight - MARGIN_Y - (dlg.offsetHeight);
        const newLeft = Math.min(Math.max(left, MARGIN_X), maxX);
        const newTop = Math.min(Math.max(top, MARGIN_Y), maxY);
        if (left !== newLeft) dlg.style.left = newLeft + 'px';
        if (top !== newTop) dlg.style.top = newTop + 'px';
      },

      mouseUp() {
        document.removeEventListener('mousemove', this.mouseMove);
        document.removeEventListener('mouseup', this.mouseUp);
      },

      mouseDown(/** @type {MouseEvent} */ event) {
        const dlg = this.state.dlg;
        if (dlg == null) return;

        dlg.oncontextmenu = () => {
          this.mouseUp();
          return;
        };

        this.state.offsetX = event.clientX - dlg.getBoundingClientRect().left;
        this.state.offsetY = event.clientY - dlg.getBoundingClientRect().top;

        document.addEventListener('mousemove', this.mouseMove);
        document.addEventListener('mouseup', this.mouseUp);
      },

      mouseMove(/** @type {MouseEvent} */ event) {
        const dlg = this.state.dlg;
        if (dlg == null) return;

        const pageX = event.pageX;
        const pageY = event.pageY;
        const left = pageX - this.state.offsetX;
        const top = pageY - this.state.offsetY;
        const rect = dlg.getBoundingClientRect();
        const maxX = window.innerWidth - MARGIN_X - (rect.right - rect.left);
        const maxY = window.innerHeight - MARGIN_Y - (rect.bottom - rect.top);
        dlg.style.left = Math.min(Math.max(left, MARGIN_X), maxX) + 'px';
        dlg.style.top = Math.min(Math.max(top, MARGIN_Y), maxY) + 'px';
      },

      onMounted() {
        /** @type {HTMLElement | null} */
        const dlg = this.$('.overlay');
        if (dlg == null) return;

        this.state.dlg = dlg;
        dlg.style.left = `${MARGIN_X}px`;
        dlg.style.top = `${MARGIN_Y}px`;
        
        dlg.onmousedown = this.mouseDown;
        dlg.ondragstart = () => {
          return false;
        };

        dlg.addEventListener('animationend', (e) => {
          if (e.animationName === 'overlayhide') {
            this.state.show = false;
            this.update();
          }
        });
      },

      onBeforeUnmount() {
        this.state.show = false;
      },

    };
  </script>

  <style>
    .overlay {
      z-index: 9999;
      position: fixed;
      max-width: 100%;
      max-height: calc(100% - 92px);
      background-color: #ffffff;
      box-shadow: 0 4px 16px 0px rgba(75, 71, 71, 0.8);
      border-radius: 4px;
      cursor: move;
    }

    .overlay-close {
      z-index: 9998;
      font-size: 20px;
      position: absolute;
      right: 0px;
      top: 0px;
      color: #ffffff;
      background-color: transparent;
      border: none;
      width: 42px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }

    @keyframes overlayshow {
      from {
        opacity: 0;
        transform: scale(.87, .87);
      }

      to {
        opacity: 1;
        transform: scale(1, 1);
      }
    }

    @keyframes overlayhide {
      from {
        opacity: 1;
        transform: scale(1, 1);
      }

      to {
        opacity: 0;
        transform: scale(.8, .8);
      }
    }

    .overlay-show {
      animation: overlayshow .1s ease-out;
    }

    .overlay-hide {
      animation: overlayhide .1s ease-out;
    }
  </style>
</kf-overlay>